import withAuth from "shared/Auth/withAuth/withAuth";
import GetUniversityQuery from "shared/University/queries/GetUniversityQuery";
import React from "react";
import compose from "lodash/flowRight";
import {graphql, withApollo} from "react-apollo";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import {withTranslation, Constants} from "@unibuddy/intl";
import withIdentify from "shared/Auth/withIdentify";
import {productSpec} from "shared/AnalyticsNew/constants/productSpecification";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import s from "./BlogCardWidget.pcss";
import EmbeddedBlogPostList from "../../../modules/Blog/containers/EmbeddedBlogPostList";
import {IntlNamespaces} from "../../../../translations/types";

export class BlogCardWidget extends React.Component {
    componentDidMount() {
        // Record Product Opened Event
        const {isProductOpenedEventEnabled} = this.props;
        if (isProductOpenedEventEnabled) {
            this.props.analytics.events.productOpened({
                name: productSpec.embeddedUniversitySocialFeed.NAME,
                universitySlug: this.props.match.params.universitySlug,
                ubLang: this.props?.i18n?.language ?? Constants.DEFAULT_LOCALE,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isProductOpenedEventEnabled !== this.props.isProductOpenedEventEnabled) {
            this.props.analytics.events.productOpened({
                name: productSpec.embeddedUniversitySocialFeed.NAME,
                universitySlug: this.props.match.params.universitySlug,
                ubLang: this.props?.i18n?.language ?? Constants.DEFAULT_LOCALE,
            });
        }
    }

    render() {
        return (
            <div className={s.container}>
                <Switch>
                    <Route
                        path={`${this.props.match.path}/:filter/:value/:limit`}
                        render={(innerProps) => (
                            <EmbeddedBlogPostList {...this.props} {...innerProps} />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}

const universityQueryOptions = {
    name: "universityQuery",
    options(props) {
        return {
            variables: {
                slug: props.match.params.universitySlug,
            },
            fetchPolicy: "cache-and-network",
        };
    },
    props({universityQuery: {university}}) {
        return {
            university,
        };
    },
};

export default compose(
    connect(),
    withApollo,
    withAuth,
    withIdentify,
    withAnalytics,
    withTranslation(IntlNamespaces.COMMON),
    graphql(GetUniversityQuery, universityQueryOptions),
)(BlogCardWidget);
